import React from 'react'
import styles from './Comentarios.module.css'
import userIcon from "../../assets/iconUser.png"
import { formFecha } from '../../utils/formFecha'

const Comentarios = ({
    id,
    usuario,
    fecha,
    contenido,
    valor,
    estrellasBool
}) => {

  const renderStars = () => {
    return [...Array(5)].map((_, index) => (
      <span
        key={index}
        className={`${styles.star} ${index < valor ? styles.activeStar : ''}`}
      >★</span>
    ));
  };

 return (
    <div className={styles.comentario} key={id}>
      <div className={styles.commentUser}>
        <div className={styles.contInfoUser}>
          <img
            className={styles.foto}
            src={usuario?.foto || userIcon}
            alt=""
          />
          <div className={styles.userComnt}>
            <div className={styles.userHeader}>
              <h3 className={styles.nombre}>
                {usuario?.nombre}
              </h3>
            </div>
            <p className={styles.fecha}>
              {formFecha(fecha)}
            </p>
          </div>
          {estrellasBool && (
            <div className={styles.estrellas}>
                {renderStars()}
              </div>
          )}
        </div>
        <div className={styles.contCommentTxt}>
          <p className={styles.commentText}>
            {contenido}
          </p>
        </div>
      </div>
    </div>
  )
}

export default Comentarios
